import React from "react";
import { useSelector } from "react-redux";
import moment from "moment";
import classes from "./CalendarEventCompactCard.module.css";

const CalendarEventCompactCard = ({ event }) => {

    const { texts } = useSelector(state => state.translate);

    const isToday = new Date(event.date).toDateString() === new Date().toDateString();
    const formattedDate = moment(new Date(event.date)).format("D.M.YYYY");

    const formatTimeRange = () => {
        const to = event.to && moment(new Date(event.to)).format("HH:mm");
        const from = event.from && moment(new Date(event.from)).format("HH:mm");
        return `${to} - ${from}`;
    };

    const getDateTimeLine = () => {
        if (isToday) {
            return event.allDayEvent ? texts.allDay : formatTimeRange();
        }
        return event.allDayEvent
            ? `${formattedDate}, ${texts.allDay ?? ""}`
            : `${formattedDate}, ${formatTimeRange()}`;
    };

    const barColor = event.holiday ? "#53C8E1" : (event.domainColor || "#00000080");
    const title = event.bagrut ? (texts.matriculationIn ?? "") + event.title : event.title;

    return (
        <div className={classes.Card}>
            <div className={classes.ColorBarWrap}>
                <div className={classes.ColorBar} style={{ backgroundColor: barColor }} />
            </div>
            <div className={classes.Content}>
                <p className={classes.DateTime}>{getDateTimeLine()}</p>
                <p className={classes.Title}>{title}</p>
            </div>
        </div>
    );
};

export default CalendarEventCompactCard;
